const state = () => ({
  condition: 1,
  sort: "DESC",
  detailList: [],
  detailListLoad: true,
});

const mutations = {
  conditionUpdate(state, value) {
    state.condition = value;
  },
  sortUpdate(state, value) {
    state.sort = value;
  },
  detailListUpdate(state, value) {
    state.detailList = value;
  },
  detailListLoadUpdate(state, value) {
    state.detailListLoad = value;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
